import PropTypes from 'prop-types';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJTextToSpeechPlayItem from '../../../../common/components/audio/FJTextToSpeechPlayItem/FJTextToSpeechPlayItem.jsx';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJDownloadIcon from '../../../../assets/svg/ttv/download.svg?react';
import FJDragIcon from '../../../../assets/svg/ttv/drag-sub.svg?react';
import FJDeleteIcon from '../../../../assets/svg/ttv/delete.svg?react';
import FJAutoTextarea from '../../../../common/components/text/FJAutoTextarea/FJAutoTextarea.jsx';
import { useState, useEffect, useRef, useMemo } from 'react';
import FJAddBase64 from '../../../../assets/base64/add-gradient.js';
import FJAddIcon from '../../../../assets/svg/add.svg?react';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import FJHandle from '../../../../common/components/FJHandle/FJHandle.jsx';
import classNames from 'classnames';
import styles from './FJTextToSpeechItem.module.less';
import FJConstant from '../../../../constants/FJConstant.js';
import FJStringUtil from '../../../../util/FJStringUtil.js';
import FJEvent from '../../../../store/FJEvent.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJS3Config from '../../../../config/FJS3Config.js';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';
import FJConfig from '../../../../config/FJConfig.js';

const FJTextToSpeechItem = props => {
    const {
        index,
        isLast,
        onDrag,
        dragId,
        isDragging,
        style,
        addSpeechParagraph,
        isSelected,
        onTextChange,
        info,
        onSelect,
        onDelete,
        canDelete,
        onGenerate,
        updateBottomCurrentTime,
        updateBottomTotalTime,
        updateIsPlay,
        onDownload,
        creditNumber,
        onEnded,
        openLibrary,
        hasGenerating,
        speechSelectId,
    } = props;
    const { id, generationType, status, audioDuration, text, voiceInfo } = info;
    const { name } = voiceInfo;

    const [isMouseIn, setIsMouseIn] = useState(false);
    const [isMouseInItem, setIsMouseInItem] = useState(false);
    const _audioPlayRef = useRef(null);
    const _textRef = useRef(null);

    useEffect(() => {
        if (speechSelectId === id) {
            _textRef.current.focus();
        }
    }, [speechSelectId, id]);

    useEffect(() => {
        const un = FJEvent.subscribe(FJ_EVENT_TYPE.CHANGE_PLAY_CURRENT_SPEECH_BY_ID, playId => {
            if (playId === id) {
                _audioPlayRef.current.play();
                updateBottomTotalTime(audioDuration);
            }
        });
        return () => {
            un();
        };
    }, [id, audioDuration]);

    useEffect(() => {
        const un = FJEvent.subscribe(FJ_EVENT_TYPE.PLAY_CURRENT_SPEECH_BY_ID, playId => {
            if (playId === id) {
                _audioPlayRef.current.play();
                updateBottomTotalTime(audioDuration);
            }
        });
        return () => {
            un();
        };
    }, [id, audioDuration]);

    useEffect(() => {
        const un = FJEvent.subscribe(FJ_EVENT_TYPE.PAUSE_CURRENT_SPEECH_BY_ID, playId => {
            if (playId === id) {
                _audioPlayRef.current.pause();
            }
        });
        return () => {
            un();
        };
    }, [id]);

    useEffect(() => {
        const un = FJEvent.subscribe(FJ_EVENT_TYPE.STOP_CURRENT_SPEECH, () => {
            _audioPlayRef.current.reset();
            updateBottomTotalTime(0);
        });
        return () => {
            un();
        };
    }, [id]);

    const _dealData = () => {
        switch (generationType) {
            case FJConstant.MICROSOFT: {
                const { audioUrl, voiceInfo } = info;
                const { value } = voiceInfo;
                return {
                    audioUrl: audioUrl ? FJS3Config.S3_SERVER_HOST + audioUrl : null,
                    avatarUrl: FJStringUtil.getTextToSpeechImgUrl(value),
                };
            }
            case FJConstant.CLONE_BY_SELF: {
                const { voiceInfo, audioUrl } = info;
                return {
                    audioUrl: audioUrl ? FJS3Config.S3_SERVER_HOST + FJConfig.resultAudioKey + audioUrl : '',
                    avatarUrl: voiceInfo.imgUrl,
                };
            }
            case FJConstant.CLONE_BY_FLEX_CLIP: {
                const { voiceInfo, audioUrl } = info;
                const { value } = voiceInfo;
                return {
                    audioUrl: audioUrl ? FJS3Config.S3_SERVER_HOST + FJConfig.resultAudioKey + audioUrl : '',
                    avatarUrl: FJTextToSpeechUtil.getVoiceStyleImgUrl(value),
                };
            }
            default:
        }
    };

    const { audioUrl, avatarUrl } = _dealData();

    const _onMouseEnter = () => {
        setIsMouseIn(true);
    };

    const _onMouseLeave = () => {
        setIsMouseIn(false);
    };

    const _onMouseEnterItem = () => {
        setIsMouseInItem(true);
    };

    const _onMouseLeaveItem = () => {
        setIsMouseInItem(false);
    };

    const _onChange = value => {
        onTextChange(id, value);
    };

    const _onDragStart = e => {
        e.preventDefault();
        onDrag(e, 'start', { dragId: id });
    };
    const _onDragging = e => {
        document.body.style.cursor = 'grabbing';
        onDrag(e, 'change', { dragId: id });
    };

    const _onDragEnd = e => {
        onDrag(e, 'end', { dragId: id });
    };

    const hasText = !!text.trim();

    const isEqual = useMemo(() => {
        return FJTextToSpeechUtil.checkIsEqual(info, info.generateInfo);
    }, [info]);

    const hasToolTip = !isEqual && hasText && creditNumber > 0;

    const _onGenerate = () => {
        if (isEqual || !hasText) {
            return;
        }
        onGenerate();
    };

    const _onPlayClick = () => {
        onSelect();
    };

    const isGenerating = status === FJConstant.GENERATING;

    return (
        <div
            className={classNames(styles.box, {
                [styles.dragging]: dragId === id,
                [styles.hover]: isDragging,
                [styles.has_bar]: canDelete,
            })}
            style={style}
            id={'text-item-' + index}
        >
            <div className={styles.num}>{FJLocalStore._('section-xxx').replace('xxx', index + 1)}</div>
            <div
                className={classNames(
                    styles.inner_box,
                    (isMouseInItem || isSelected) && canDelete ? styles.hover : null,
                    isMouseInItem && !isSelected ? styles.text_hover : null,
                )}
                onClick={onSelect}
            >
                <FJHoverBoardGradation active={isSelected} borderRadius={8} hasHover={false}>
                    <div className={styles.content} onMouseEnter={_onMouseEnterItem} onMouseLeave={_onMouseLeaveItem}>
                        <div className={styles.header}>
                            <div className={styles.left}>
                                <FJToolTip
                                    title={
                                        hasToolTip
                                            ? `-${FJTextToSpeechUtil.getUsedCreditByTextLength(text.trim().length)} ${FJLocalStore._('credits')}`
                                            : null
                                    }
                                >
                                    <div>
                                        <FJTextToSpeechPlayItem
                                            audioUrl={audioUrl}
                                            onGenerate={_onGenerate}
                                            isGenerating={isGenerating}
                                            ref={_audioPlayRef}
                                            updateCurrentTime={updateBottomCurrentTime}
                                            updateIsPlay={updateIsPlay}
                                            isEqual={isEqual}
                                            onPlayClick={_onPlayClick}
                                            onEnded={onEnded}
                                        />
                                    </div>
                                </FJToolTip>
                                <div className={styles.img_box} onClick={openLibrary}>
                                    <img src={avatarUrl} alt='' />
                                </div>
                                <FJTextWithEllipsis className={styles.name} text={name} onClick={openLibrary} />
                            </div>
                            <div className={styles.right}>
                                {status === FJConstant.SUCCESS && (
                                    <FJButton
                                        className={styles.icon_btn}
                                        type='white'
                                        icon={<FJDownloadIcon />}
                                        onClick={() => {
                                            onDownload(audioUrl);
                                        }}
                                    />
                                )}
                                {!isGenerating && (
                                    <FJButton
                                        className={classNames(styles.icon_btn, styles.delete_icon)}
                                        type='white'
                                        icon={<FJDeleteIcon />}
                                        onClick={onDelete}
                                        disabled={isGenerating}
                                    />
                                )}
                                {status === FJConstant.SUCCESS && (
                                    <div className={styles.time}>{FJUtil.formatTime(audioDuration, false, 2)}</div>
                                )}
                            </div>
                        </div>
                        <div className={classNames(styles.text_box, isSelected ? styles.text_border : null)}>
                            <FJAutoTextarea
                                placeholder={FJLocalStore._('please-enter-text-here')}
                                onChange={_onChange}
                                text={text}
                                disabled={isGenerating}
                                maxLength={4000}
                                ref={_textRef}
                            />
                        </div>
                    </div>
                </FJHoverBoardGradation>
                <FJHandle
                    style={{ display: 'block' }}
                    onDragStart={_onDragStart}
                    onDrag={_onDragging}
                    onDragEnd={_onDragEnd}
                    render={() => {
                        return (
                            <div className={styles.drag}>
                                <div className={styles.drag_inner}>
                                    <FJDragIcon />
                                </div>
                            </div>
                        );
                    }}
                />
            </div>

            {!isLast ? (
                <div className={classNames(styles.bottom, isDragging || hasGenerating ? styles.disabled_btn : null)}>
                    <div
                        className={styles.add_btn}
                        onClick={() => {
                            addSpeechParagraph(index + 1);
                        }}
                    >
                        <img src={FJAddBase64} alt='' />
                        {FJLocalStore._('add-new-section')}
                    </div>
                </div>
            ) : (
                <div className={classNames(styles.last_box, isDragging || hasGenerating ? styles.disabled_btn : null)}>
                    <FJHoverBoardGradation
                        active={isMouseIn}
                        borderRadius={20}
                        style={{ boxShadow: `0px 1px 4px 0px rgba(114,118,137,0.10)` }}
                    >
                        <div
                            className={styles.last}
                            onMouseEnter={_onMouseEnter}
                            onMouseLeave={_onMouseLeave}
                            onClick={() => {
                                addSpeechParagraph();
                            }}
                        >
                            <div className={styles.add_icon}>
                                <FJAddIcon />
                            </div>
                            {FJLocalStore._('add-new-section')}
                        </div>
                    </FJHoverBoardGradation>
                </div>
            )}
        </div>
    );
};

FJTextToSpeechItem.propTypes = {
    info: PropTypes.object,
    index: PropTypes.number,
    isLast: PropTypes.bool,
    onDrag: PropTypes.func,
    dragId: PropTypes.number,
    isDragging: PropTypes.bool,
    style: PropTypes.object,
    addSpeechParagraph: PropTypes.func,
    isSelected: PropTypes.bool,
    onTextChange: PropTypes.func,
    onGenerate: PropTypes.func,
    canDelete: PropTypes.bool,
    onDelete: PropTypes.func,
    onSelect: PropTypes.func,
    onDownload: PropTypes.func,
    creditNumber: PropTypes.number,
    onEnded: PropTypes.func,
    openLibrary: PropTypes.func,
    updateBottomCurrentTime: PropTypes.func,
    updateBottomTotalTime: PropTypes.func,
    updateIsPlay: PropTypes.func,
};
export default FJTextToSpeechItem;
